<!--
极致游戏公司简介

动画流程:
1. title, bar, desc 在进入窗口范围后分别以 1s 的速度从下向上淡入
2. swiper 在进入窗口范围后以 1s 的速度从右向左淡入

tablet 以下适配:
1. illus 右移 200
2. bar, desc 宽度增加 200
-->
<template>
  <div id="js-company">
    <div id="js-company-wrap" :class="$style.company">
      <div id="js-company-illus" :class="$style.illus">
        <the-company-illus class="app-fadeInLeft" />
      </div>
      <h2 id="js-company-title" :class="$style.title">
        <span class="app-fadeInUp">公司简介</span>
      </h2>
      <div id="js-company-bar" :class="$style.bar">
        <div :class="[$style.bar_wrap, 'app-fadeInUp']">
          <img src="./images/company-intro-bar-mini.png" />
        </div>
      </div>
      <div id="js-company-desc" :class="$style.desc">
        <div :class="[$style.desc_wrap, 'app-fadeInUp']" v-html="intro" />
      </div>
    </div>
  </div>
</template>

<script>
import aboutMixins from '@/assets/js/aboutMixins'
import TheCompanyIllus from './TheCompanyIllus'

export default {
  components: { TheCompanyIllus },
  mixins: [aboutMixins],
  props: { intro: { type: String, default: '' } },
  data() {
    return {
      name: 'company',
      animateScenesData: [
        { title: 'illus', direction: 'Left' },
        'title',
        'bar',
        'desc',
      ],
    }
  },
}
</script>

<style lang="less" module>
@company-padding-left: 1.6rem;
@company-cont-width: 7.75rem;
@company-bar-height: 1.29rem;

.company {
  position: relative;
  min-height: 10.53rem;
  margin-top: -0.71rem;
  padding: 2.17rem 0 @padding-base-title @company-padding-left;
  box-sizing: border-box;
}

.illus {
  position: absolute;
  top: 0;
  right: 0;
}

.title {
  margin-bottom: @padding-title-bot;

  span {
    .subtitle-size(1.46rem, 0.58rem);
    .text-hide();
    display: inline-block;
    vertical-align: top;
    background: url('./images/company-intro-title.png') no-repeat;
    background-size: 100% 100%;
  }
}

.bar {
  margin-bottom: @padding-title-bot;

  &_wrap {
    .size(@company-cont-width, @company-bar-height);
    background: url('./images/company-intro-bar.png') no-repeat;
    background-size: 100% 100%;

    img {
      display: none;
    }
  }
}

.desc {
  z-index: 1;
  position: relative;
  width: @company-cont-width;

  &_wrap {
    line-height: 1.8;

    p {
      margin-bottom: 1.7em;
      text-indent: 2em;
    }
  }
}

@media screen and (max-width: @tablet-width) {
  @add: 2rem;

  .illus {
    right: -@add;
  }

  .bar_wrap,
  .desc {
    width: @company-cont-width + @add;
  }

  .bar_wrap {
    height: @company-bar-height +
      (@add / @company-cont-width * @company-bar-height);
  }
}

@media screen and (max-width: @mini-width) {
  .company {
    padding-top: 2.8rem;
  }

  .title,
  .illus {
    display: none;
  }

  .bar_wrap {
    .size(auto);
    margin-right: @company-padding-left;
    background: none;

    img {
      .size(100%, auto);
      display: block;
    }
  }

  .desc {
    width: auto;
    margin-right: @company-padding-left;
  }
}

@media screen and (max-width: @mobile-width) {
  .company {
    padding-top: 3.5rem;
  }
}
</style>
